module.exports = __webpack_public_path__ + "img/株式会社政軒は、アジア圏を中心に日本製の商品の輸出販売業を行っております。 各国の取引先からいただく「メイドインジャパン」商品.8defa636.png";